/**
 * @internal used to identify `@validate` decorators on class metadata
 */
export const VALIDATE_METADATA_KEY = Symbol("VALIDATE_METADATA_KEY");
